// This will include all the state and any actions that relate to github such as searchUsers etc
import React, { useReducer } from 'react';
import AlertContext from './alertContext'
import AlertReducer from './alertReducer'
import {
  SET_ALERT,
  REMOVE_ALERT
} from '../types'

const AlertState = props => {
  const initialState = null

  const [state, dispatch] = useReducer(AlertReducer, initialState);

  // Set alert
  const setAlert = (msg, type) => {
    dispatch({
      type : SET_ALERT,
      payload : { msg, type}
    })

    setTimeout(() => dispatch({ type : REMOVE_ALERT}), 5000);
  };


// Set Alert

  return <AlertContext.Provider 
  value={{
    alert : state,
    setAlert
  }}
  >
{props.children}
</AlertContext.Provider>
}

export default AlertState;